export default __webpack_public_path__ + "static/media/step-2.fb8d3ccb.png";